import { Component } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faFileInvoiceDollar, faHandshake } from "@fortawesome/free-solid-svg-icons";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-how-it-works",
    styleUrls: ["./landing-page-shared.scss", "./how-it-works.component.scss"],
    template: `
		<section class="how-it-works how-it-works__background">
			<h2 class="responsive-text--large how-it-works__title">{{ 'landing.how-it-works' | translate }}</h2>
			<ol class="how-it-works__list">
				<li
					class="how-it-works__list-item how-it-works__list-item--first how-it-works__list-item--dot-after"
				>
					<div class="how-it-works__list-item-inner">
						<fa-icon [icon]="['fas', 'cart-shopping']" class="fa-lg" />

						{{ 'landing.consumers-post-orders' | translate }}
					</div>
					<div class="marching-ants--horizontal"></div>
				</li>
				<li
					class="how-it-works__list-item how-it-works__list-item--second how-it-works__list-item--dot-before"
				>
					<div class="marching-ants--horizontal marching-ants--horizontal-reverse"></div>

					<div class="how-it-works__list-item-inner">
						<fa-icon [icon]="faFileInvoiceDollar" class="fa-lg" />

						{{ 'landing.vendors-review-orders' | translate }}
					</div>
				</li>
				<li
					class="how-it-works__list-item how-it-works__list-item--third how-it-works__list-item--dot-after"
				>
					<div class="how-it-works__list-item-inner">
						<fa-icon [icon]="faHandshake" class="fa-lg" />

						{{ 'landing.consumers-evaluate-proposals' | translate }}
					</div>
					<div class="marching-ants--horizontal"></div>
				</li>
				<li
					aria-hidden="true"
					class="how-it-works__list-item--divider marching-ants--vertical"
				></li>
			</ol>
		</section>
	`,
    imports: [FontAwesomeModule, TranslatePipe],
})
export class HowItWorksComponent {
	faHandshake = faHandshake;
	faFileInvoiceDollar = faFileInvoiceDollar;
}
